/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DisableUserFeature403,
  EnableUserFeature403,
  SchemaValidationErrorResponse,
  StandardError,
  UserFeature
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary User Feature Flags
 */
export const userFeatures = (

 signal?: AbortSignal
) => {


      return axiosClient<UserFeature[]>(
      {url: `/user-features`, method: 'GET', signal
    },
      );
    }




export const getUserFeaturesQueryKey = () => {
    return [
    'user-features'
    ] as const;
    }


export const getUserFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof userFeatures>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userFeatures>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userFeatures>>> = ({ signal }) => userFeatures(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userFeatures>>, TError, TData>
}

export type UserFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof userFeatures>>>
export type UserFeaturesQueryError = ErrorType<StandardError>


/**
 * @summary User Feature Flags
 */

export function useUserFeatures<TData = Awaited<ReturnType<typeof userFeatures>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Disable User Feature
 */
export const disableUserFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<UserFeature>(
      {url: `/user-features/${id}/disable`, method: 'PUT', signal
    },
      );
    }




export const getDisableUserFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | DisableUserFeature403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUserFeature>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableUserFeature>>, TError,{id: string}, TContext> => {

const mutationKey = ['disableUserFeature'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableUserFeature>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  disableUserFeature(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableUserFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof disableUserFeature>>>

    export type DisableUserFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | DisableUserFeature403>

    /**
 * @summary Disable User Feature
 */
export const useDisableUserFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | DisableUserFeature403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableUserFeature>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableUserFeature>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDisableUserFeatureMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable User Feature
 */
export const enableUserFeature = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<UserFeature>(
      {url: `/user-features/${id}/enable`, method: 'PUT', signal
    },
      );
    }




export const getEnableUserFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | EnableUserFeature403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUserFeature>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableUserFeature>>, TError,{id: string}, TContext> => {

const mutationKey = ['enableUserFeature'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableUserFeature>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  enableUserFeature(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableUserFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof enableUserFeature>>>

    export type EnableUserFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | EnableUserFeature403>

    /**
 * @summary Enable User Feature
 */
export const useEnableUserFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | EnableUserFeature403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableUserFeature>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableUserFeature>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getEnableUserFeatureMutationOptions(options), queryClient);
    }
